import api from '@/plugins/api'
import requestValidation from '@/configs/requestValidation'
import {inspection as endpoint} from '@/configs/endpoints'

export default {
  state: () => ({
    isLoad: false
  }),
  actions: {
    async connectEquipmentMeasurementForSelectedWindow (context, data) {
      const response = await api.post(endpoint.zigBeeEquipment(data.params), {body: data.body})
      if (await requestValidation(response)) {
        return response
      } else {
        if (response?.code === 400)
          context.dispatch('getEquipmentsList', { type_inspection: 'light_transmission' })
        return false
      }
    },
    async updateEquipmentMeasurement (context, data) {
      const response = await api.patch(endpoint.zigBeeEquipment(data.params), {body: data.body})
      if (await requestValidation(response)) {
        return response
      }
    },
    async startMeasurementForSelectedWindow (context, params) {
      const response = await api.post(endpoint.startMeasurementForZigBeeEquipment(params))
      if (await requestValidation(response)) {
        return response
      }
    },
    // async getResultMeasurementForSelectedWindow (context, data) {
    //   const params = {
    //     id: data.id,
    //     number: data.number,
    //     type: 'light_transmission',
    //   }
    //   const response = await api.get(endpoint.zigBeeEquipment(params))

    //   if (await requestValidation(response)) {
    //     return response.data
    //   }
    // }
  }
}
